import {HomeIdResponseInterface} from "../../interfaces/home.interface";

export const homeInitialState: HomeIdResponseInterface = {
    requestState: 'IDLE',
    id: undefined
}
